import {
  Receipt,
  SendToMobile,
} from '@mui/icons-material';
import { RESOURCES, ACTIONS } from '../../../hooks/useAccessControl';

// Online (SchoolPay) payments are fee payments, so they live as a group
// inside Fee Management (see feesMenu) rather than as a top-level menu.
// Leaf ids and routes (/schoolpay/*) are unchanged so existing links work.
// Gated on fees/payments like the backend /schoolpay routes.
export const schoolPayMenu = {
  type: 'group',
  id: 'fees-online-payments',
  label: 'Online Payments (SchoolPay)',
  children: [
    {
      id: 'schoolpay-transactions',
      label: 'SchoolPay Transactions',
      icon: Receipt,
      permission: { resource: RESOURCES.FEES.PAYMENTS, action: ACTIONS.READ },
    },
    {
      id: 'schoolpay-adhoc',
      label: 'Payment Requests',
      icon: SendToMobile,
      permission: { resource: RESOURCES.FEES.PAYMENTS, action: ACTIONS.READ },
    },
  ],
};
